import React from 'react';
import { StepComponentProps, StepDefinition } from './StepDefinition';
import { RestaurantFacade } from 'pos/facades';
import { StepLoader } from './StepLoader';
import { RecipeIngredientDTO, RemovedIngredientDTO, Res } from 'core/api';
import { VStack, Text, Box, Grid } from '@chakra-ui/react';
import { SvgIcon } from 'core/ui-next';
import { Success, Error as ErrorImg } from 'core/img';
import { CompositionState } from './Composition';
import { useCompositionSetters } from './useCompositionSetters';


async function validate(_composition: CompositionState): Promise<boolean> {
	return true;
}

function toRemovedIngredient(ingredient: RecipeIngredientDTO): RemovedIngredientDTO {
	return { ProductId: ingredient.ProductId, SaleFormatName: ingredient.SaleFormatName, SaleFormatId: ingredient.SaleFormatId, Style: ingredient.Style };
}

function clean(composition: CompositionState): CompositionState {
	return { ...composition, removedIngredients: [] };
}

const RemoveIngredientsComposition = (
	props: StepComponentProps & { ingredients: RecipeIngredientDTO[] }
) => {

	const { ingredients, composition, setComposition } = props;
	const { setRemovedIngredients } = useCompositionSetters(setComposition);

	const onSelectIngredient = (ingredient: RecipeIngredientDTO) => {

		const exists = composition.removedIngredients.some(
			(x) => x.SaleFormatId === ingredient.SaleFormatId
		);

		if (exists)
			setRemovedIngredients(composition.removedIngredients.filter((x) => x.SaleFormatId !== ingredient.SaleFormatId));
		else
			setRemovedIngredients([
				...composition.removedIngredients,
				toRemovedIngredient(ingredient)
			]);
	};

	return (
		<Grid templateColumns={'repeat(2, 1fr)'} gap={'4'} height={'full'} overflowY={'auto'} overflowX={'hidden'}>
			{ingredients.map((x) => {
				const selected = composition.removedIngredients.some(
					(i) => i.SaleFormatId === x.SaleFormatId
				);

				return (
					<Box
						key={x.SaleFormatId}
						display={'flex'}
						justifyContent={'flex-start'}
						alignItems={'center'}
						gap={'2'}
						cursor={'pointer'}
						onClick={() => onSelectIngredient(x)}
					>
						<Box width={'5'} height={'5'}>
							<SvgIcon w={'5'} h={'5'} src={selected ? ErrorImg : Success} color={selected ? 'red.700' : 'green.600'} />
						</Box>
						<Text fontSize={'sm'} textDecoration={selected ? 'line-through' : 'none'}>{x.Style.Text}</Text>
					</Box>
				);
			})}
		</Grid>
	);
};
export const Component = (props: StepComponentProps) => {

	const getData = React.useCallback(async (composition: CompositionState) => {

		const selectedProduct = composition.selectedProduct;
		if (selectedProduct === null)
			throw new Error('Product has not been selected');

		const ingredients = await RestaurantFacade.getRecipeIngredients(selectedProduct.SaleFormatId);
		return { ingredients };

	}, []);

	return <StepLoader {...props} getData={getData}>
		{(props) =>
			<VStack width={'full'} height={'full'} gap={'12'} overflow={'auto'}>
				<VStack width={'full'} gap={'4'} alignItems={'flex-start'} overflow={'auto'}>
					<Text fontSize={'md'} fontWeight={'semibold'}>{Res.Web.ADJUST_INGREDIENTS_LBL()}</Text>
					<Box width={'full'} height={'full'} padding={'4'} overflow={'auto'}>
						<RemoveIngredientsComposition {...props} />
					</Box>
				</VStack>
			</VStack>
		}
	</StepLoader>;
};

const step: StepDefinition = {
	id: 'RemovedIngredients',
	label: Res.Web.WIZARD_COMPOSE_SELECT_INGREDIENTS_LBL(),
	canFinish: false,
	useKeyPad: false,
	validate,
	clean,
	Component
};

export default step;
